import {environment} from "../../../environments/environment";
import {AppContexEnum} from "../enums/app-contex.enum";

export const isPartner = (environment.context === AppContexEnum.Partners);
